<script setup>
import { init, use } from 'echarts/core'
import { SVGRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import { TooltipComponent } from 'echarts/components'
import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps(['data', 'name'])
const chartContainer = ref(null)
let chartInstance = null

use([
  SVGRenderer,
  PieChart,
  TooltipComponent,
])

const initChart = () => {
  if(chartContainer.value) {
    chartInstance = init(chartContainer.value)

    chartInstance.setOption({
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
      },
      series: [
        {
          name: props.name,
          type: 'pie',
          radius: '75%',

          data: JSON.parse(props.data),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ]
    })
  }
}

const handleResize = () => {
  if(chartInstance) {
    chartInstance.resize()
  }
}

const disposeChart = () => {
  if(chartInstance) {
    chartInstance.dispose()
  }
  chartInstance = null
  chartContainer.value = null
}

onMounted(() => {
  initChart()
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  disposeChart()
})
</script>

<template>
    <div v-if="props.data.length > 2" class="piechart-container mx-auto" ref="chartContainer" v-init-vue></div>
    <p v-else class="text-center mt-4" v-init-vue>Für diesen Zeitraum sind keine Daten vorhanden. Bitte einen anderen Zeitraum wählen.</p>
</template>

<style scoped>
  .piechart-container {
    width: 1165px;
    max-width: 100%;
    height: 550px;
  }
</style>